// extracted by mini-css-extract-plugin
export var container = "_60-0";
export var fallback = "_60-5";
export var fallbackIcon = "_60-6";
export var hidden = "_60-2";
export var image = "_60-3";
export var loaded = "_60-4";
export var placeholder = "_60-1";